const CheckStatus = ({ children, actual, required }) => (
  actual !== null && required.includes(actual)
    ? children
    : []
);

export default CheckStatus;
